import {
  userHasEditorAccess,
  userHasLevel1OnlyAccess
} from "@utils/projectAccess";
import { getSectionVisibility } from "@shared/section-registry/sectionVisibility";
import { ContractorPackageLineItem } from "catchment-common/interfaces/contractorPackage";
import { OrganisationLineItem } from "catchment-common/interfaces/organisation";
import { ProjectLineItem } from "catchment-common/interfaces/project";
import { SideBarMenuModelLineItem } from "catchment-common/interfaces/sidebarMenu";
import { NavItemListType } from "types";

import { getManageNav } from "./manage";
import { getOverviewNav } from "./overview";
import { getPackageNav } from "./analytics";
import { getDirectoryNav } from "./search";
import { getReducedReportNav, getReportsNav } from "./submit";

export const getNavMenuItems = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem,
  organisation?: OrganisationLineItem,
  sideBarMenuModel?: SideBarMenuModelLineItem,
  isHeadContractorPackage = false
): NavItemListType => {
  const items = [];
  const isFlatNav = userHasLevel1OnlyAccess(project);

  // The shared nav keeps its dashboard inside the one flat list it is.
  if (!isFlatNav) {
    items.push(getOverviewNav(project, contractorPackage));
  }

  const packageNav = getPackageNav(
    project,
    contractorPackage,
    isHeadContractorPackage
  );
  // A project with no visible section has an empty Analytics group now that the
  // dashboard has left it, and an empty group draws a caption over nothing.
  if ((packageNav.children ?? []).length > 0) {
    items.push(packageNav);
  }

  const visibility = getSectionVisibility(project, contractorPackage);
  const hasAnyVisibleSection =
    visibility.isLabourHoursVisible ||
    visibility.isSocialSpendVisible ||
    visibility.isLocalContentVisible ||
    visibility.isDocumentsVisible ||
    visibility.isEnvironmentalVisible;
  // Level1Only (shared) users have no Manage items — Work Packages is hidden and
  // Workforce/Forecasting are editor-only — so the group would render empty.
  if (hasAnyVisibleSection && userHasEditorAccess(project)) {
    items.push(getManageNav(project, contractorPackage, organisation));
  }

  if (isHeadContractorPackage) {
    items.push(getReportsNav(project, contractorPackage, sideBarMenuModel));
  } else {
    items.push(
      getReducedReportNav(
        project,
        contractorPackage,
        organisation,
        sideBarMenuModel
      )
    );
  }

  // Level1Only (shared) users don't get Export Types / Smart Directory.
  if (!userHasLevel1OnlyAccess(project)) {
    items.push(getDirectoryNav(project, contractorPackage));
  }

  return { items };
};
